import { ICountryCodes } from '../types';

export const CHANGE_DICTIONARY_COUNTRY_CODES = 'DICTIONARIES :: CHANGE_COUNTRY_CODES';

export type TChangeDictionaryCountryCodesAction = {
  type: typeof CHANGE_DICTIONARY_COUNTRY_CODES;
  payload: ICountryCodes;
};

export function changeDictionaryCountryCodes(payload: ICountryCodes): TChangeDictionaryCountryCodesAction {
  return {
    type: CHANGE_DICTIONARY_COUNTRY_CODES,
    payload,
  };
}
